import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import Table from '../Table/Table';
import { Tables, Checkbox, Input, InputChange } from '@ixyberfree/ixybercomponents';
import './alarm.css';

interface IAlarm {
    visible?: boolean;
}

function OperatorGuideMessage(props: IAlarm) {
    const tabAlarmRef = useRef<HTMLDivElement>(null);

    const [data, setData] = React.useState<any>([]);

    const buttonData = [
        { label: 'Print', id: 'menutopbutprint', className: 'button-style print' },
        {
            label: 'Acknowledge',
            id: 'menutopbutack',
            className: 'button-style ack',
            onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                const ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.OG.Messages;
                const ids = [];
                for (const activeElement of ActiveEvents) {
                    const hasAck = ((activeElement.NewState >> 2) & 1) == 1;
                    if (hasAck) ids.push(activeElement.id);
                }
                if (ids.length != 0) window.Base.Events.AckEvents(ids);
            }
        },
        {
            label: 'Delete',
            id: 'menutopbutcross',
            className: 'button-style cross',
            onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                const ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.OG.Messages;
                const ids = [];
                for (const activeElement of ActiveEvents) {
                    const hasAck = ((activeElement.NewState >> 2) & 1) == 1;
                    if (!hasAck) ids.push(activeElement.id);
                }
                if (ids.length != 0) window.Base.Events.RemoveEvents(ids);
            }
        },
        { label: 'Dialog', id: 'menutopbutdialog', className: 'button-style dialog' },
        { label: 'Stop/Resume', id: 'menutopbutpause', className: 'button-style stop-resume' },
        { label: 'Filter', id: 'menutopbutfilter', className: 'button-style filter' }
    ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            let ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.OG.Messages;
            setData(ActiveEvents);
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    //Данные для теста таблицы
    const redsquare = '<div style="width: 15px; height: 15px; background-color: red; transform: rotate(45deg);"></div>';

    return (
        <div className={`alarm`} style={{ width: '100%', height: '100%' }}>
            <div className={`alarm__tab`} ref={tabAlarmRef}>
                {buttonData.map(({ label, id, className, onClick }) => (
                    <button
                        key={id}
                        id={id}
                        className={className}
                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            if (onClick) {
                                onClick(event);
                            }
                        }}></button>
                ))}
            </div>
            <div className={`alarm__table`} style={{ width: 'calc(100% - 12px)', height: 'calc(100% - 50px)' }}>
                <Table
                    header={[
                        {
                            type: 'element',
                            width: '30px',
                            label: '',
                            idCol: 'selected',
                            action: false
                        },
                        {
                            type: 'number',
                            width: '50px',
                            label: '',
                            idCol: 'indexNumber',
                            action: false
                        },
                        {
                            type: 'element',
                            width: '25px',
                            label: '',
                            idCol: 'alarm',
                            action: false
                        },
                        {
                            type: 'element',
                            width: '700px',
                            label: '',
                            idCol: 'date',
                            action: false
                        },
                        {
                            type: 'element',
                            width: '200px',
                            label: '',
                            idCol: 'time',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '50px',
                            label: '',
                            idCol: 'AM',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '120px',
                            label: '',
                            idCol: 'folder',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '200px',
                            label: '',
                            idCol: 'error',
                            action: false
                        }
                    ]}
                    data={data}
                    width="100%"
                    height="100%"
                    paging={true}
                />
            </div>
        </div>
    );
}

export default OperatorGuideMessage;
